// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__pQR+W","main":"Breadcrumb_main__lqnjC","breadcrumb--placeholder":"Breadcrumb_breadcrumb--placeholder__WMf77"};